import React, { useState } from "react";
import { useDispatch } from "react-redux";
import ChangePasswordForm from "../../components/ChangePasswordForm";
import { setUser } from "../../redux/Slice/authSlice";
import { errorMessage } from "../../services";
import { updateProfile } from "../../services/auth";
import { ROLE_LABELS } from "../../utils/format";
import { Spinner } from "../../components/Loader";

function AccountForm({ user, notify }) {
  const dispatch = useDispatch();
  const [form, setForm] = useState({ name: user.name || "", email: user.email || "", phone: user.phone || "" });
  const [busy, setBusy] = useState(false);
  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const payload = { name: form.name.trim(), phone: form.phone.trim() };
      if (form.email.trim()) payload.email = form.email.trim();
      const { data } = await updateProfile(payload);
      dispatch(setUser(data.user));
      notify("Profile updated");
    } catch (err) {
      notify(errorMessage(err), "error");
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit}>
      <label className="admin-field">Full name<input required minLength={2} value={form.name} onChange={set("name")} /></label>
      <label className="admin-field">Email<input type="email" value={form.email} onChange={set("email")} /></label>
      <label className="admin-field">Mobile number<input value={form.phone} onChange={set("phone")} /></label>
      <button className="primary-btn" disabled={busy}>{busy ? <><Spinner /> Saving</> : "Save profile"}</button>
    </form>
  );
}

// Everyone: account details and password. (A store owner's website settings have their own tab: Store settings.)
export default function ProfileTab({ user, notify }) {
  return (
    <>
      <div className="page-heading">
        <div>
          <p className="eyebrow">ACCOUNT SETTINGS</p>
          <h1>Profile</h1>
          <p className="subheading">Signed in as {user.email || user.phone} · {ROLE_LABELS[user.role]}</p>
        </div>
      </div>
      {user.role === "support" ? (
        // A Support Admin's details and password are set by the Super Admin
        <div className="settings-sections">
          <section className="settings-card">
            <div className="settings-card-heading"><span className="settings-card-icon">♙</span><div><h3>Your account</h3><p>Set by the Super Admin.</p></div></div>
            <p><b>{user.name}</b><br />{[user.email, user.phone].filter(Boolean).join(" · ")}</p>
            <p className="muted">🔒 Your password is set by the Super Admin and can&apos;t be changed here. Forgot it, or need a change? Ask the Super Admin.</p>
          </section>
        </div>
      ) : (
      <div className="settings-sections">
        <section className="settings-card">
          <div className="settings-card-heading"><span className="settings-card-icon">♙</span><div><h3>Your account</h3><p>Your name and contact details.</p></div></div>
          <AccountForm user={user} notify={notify} />
        </section>
        <section className="settings-card">
          <div className="settings-card-heading"><span className="settings-card-icon">🔒</span><div><h3>Password</h3><p>Changing it signs you out on other devices.</p></div></div>
          <ChangePasswordForm />
        </section>
      </div>
      )}
    </>
  );
}
